/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI WL
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChatThreadModel } from './ChatThreadModel';
import {
    ChatThreadModelFromJSON,
    ChatThreadModelFromJSONTyped,
    ChatThreadModelToJSON,
    ChatThreadModelToJSONTyped,
} from './ChatThreadModel';

/**
 * 
 * @export
 * @interface ChatThreadModelPagedList
 */
export interface ChatThreadModelPagedList {
    /**
     * 
     * @type {number}
     * @memberof ChatThreadModelPagedList
     */
    readonly totalCount: number;
    /**
     * 
     * @type {Array<ChatThreadModel>}
     * @memberof ChatThreadModelPagedList
     */
    readonly entities: Array<ChatThreadModel>;
}

/**
 * Check if a given object implements the ChatThreadModelPagedList interface.
 */
export function instanceOfChatThreadModelPagedList(value: object): value is ChatThreadModelPagedList {
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('entities' in value) || value['entities'] === undefined) return false;
    return true;
}

export function ChatThreadModelPagedListFromJSON(json: any): ChatThreadModelPagedList {
    return ChatThreadModelPagedListFromJSONTyped(json, false);
}

export function ChatThreadModelPagedListFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatThreadModelPagedList {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'],
        'entities': ((json['entities'] as Array<any>).map(ChatThreadModelFromJSON)),
    };
}

export function ChatThreadModelPagedListToJSON(json: any): ChatThreadModelPagedList {
    return ChatThreadModelPagedListToJSONTyped(json, false);
}

export function ChatThreadModelPagedListToJSONTyped(value?: Omit<ChatThreadModelPagedList, 'totalCount'|'entities'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
    };
}

